import { useTranslation } from 'react-i18next';

import { useRejectQuotation } from '~/api/quotations';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  onClose: () => void;
  quotationId: number;
};

export const RejectQuotationDialog = ({ onClose, quotationId }: Props) => {
  const { t } = useTranslation(['common', 'quotations']);

  const mutation = useRejectQuotation(quotationId);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('quotations:overview.declineModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('quotations:overview.declineModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="CloseSmall"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => onClose(),
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('quotations:overview.rowActions.decline')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
